import { SelectorValue } from "../../../common/input/Selector/SelectorValue";

export const chosenValues = (
  chosen: readonly string[] | null | undefined,
  found: readonly SelectorValue[] | null | undefined,
  labelUnfound: (value: string, unfoundCount: number) => string,
): SelectorValue[] => {
  const ids = chosen ?? [];
  const unfoundCount = ids.filter((id) => !found?.some((option) => option.value === id)).length;
  return ids.map(
    (id) => found?.find((option) => option.value === id) ?? { value: id, label: labelUnfound(id, unfoundCount) },
  );
};
